import React, { useState } from 'react'
import styled from 'styled-components/macro'
import { theme } from 'twin.macro'

import infoIcon from '../../../assets/icons/info-icon.png'
import infoIconOrange from '../../../assets/icons/info-icon-orange.png'

const MedicalInformationAnchor = styled.span`
    display: flex;
    align-items: center;
    :hover {
        p { 
            color: ${theme`colors.orange`};
            transition: 0s;
        }
    }
    p {
        margin-right: 5px;
    }
    img {
        width: 25px;
    }
`

const MedicalInformation = ({ setShowExitModal, setExitUrl, setExitModalCopy }) => {
    const [hovering, setHovering] = useState(false)

    return(
        <MedicalInformationAnchor onClick={() => {
            setShowExitModal(true)
            setExitUrl("https://www.regeneron.com/medical-inquiries")
            setExitModalCopy("You are being redirected to Regeneron’s Medical Information page. This website is hosted by Regeneron Pharmaceuticals Inc.")
            }} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
            <p>Medical Information</p>
            {!hovering ? (
                <img src={infoIcon} alt="info-icon" />
            ) : (
                <img src={infoIconOrange} alt="info-icon-orange" />
            )}
        </MedicalInformationAnchor>
    )
}

export default MedicalInformation
